import { Pipe, PipeTransform } from '@angular/core';
import { ProjectLanguage } from '../../firestore-models/project-language';

@Pipe({
  name: 'multiStringMessage',
  standalone: false,
})
export class MultiStringMessagePipe implements PipeTransform {

  transform(values: Array<{lang_code: string, string_message: string}>, languages: Array<ProjectLanguage>,currentLang: string = 'ja'): string {
    let string_message: string = '';
    if (!!values) {
      // const language = languages[0];
      const language = languages.find(lang => lang.lang_code === currentLang);//#216 日本語固定になっているので、admin_lang_modeに従って出し分ける
      if (language) {
        for (const value of values) {
          if (language.lang_code === value.lang_code) {
            string_message = value.string_message;
            break;
          }
        }
      }
    }
    return string_message;
  }

}
